<div [class.isPrinting]="printService.isPrinting">
 

  <div class="row">
    <div class="col-md-12 padding-right-0px padding-left-0px margin-top-10">
      <div class="card">
        <div class="card-header wh-header font-size-16px font-weight-normal border-bottom1px-solidgray border-left15px-solidgray padding-top-6px padding-left-15px">
          <div class="row">
            <div class="col-md-3">
              <label class="margin-bottom-0px color-backarrow font-size-25px font-weight-bold">Visits</label>
            </div>
         
          </div>
        </div>
        <div class="card-body padding-all-0px">
          <div class="row margin-left-10px">
            <div class="col-md-12">
              <div class="table-component">
                <div class="table-responsive overflow-x-hidden">


                  <table class="table table-striped margin-left-zero">

                    <thead class="">
                      <tr>
                        <th class="td-width-100px">Date</th>

                       
                        <th>Services</th>
                    
                       
                      </tr>
                    </thead>
                    <tbody class="table-body">
                      <tr *ngFor="let l of CurrentPatientVisitDetailsController">



                        <td class="padding-right-0px padding-top-0px padding-bottom-0px">{{l.VisitDate|date:'dd-MM-yyyy'}}</td>

                        <td class="padding-top-0px padding-bottom-0px">{{l.Services}}</td>
                       
                      
                      </tr>

                    </tbody>

                  </table>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>

  </div>

  

  


  <router-outlet></router-outlet>
  <router-outlet name="print"></router-outlet>
</div>

  <!--<div class="row" *ngIf="Formedit">
    <div class="col-md-8 padding-left-0px">


      <div class="card">

        <div class="card-body padding-all-0px">
          <div *ngIf="FormData" class="margin-top-10">


            <div class="row card margin-left-0px margin-right-0px margin-bottom-5px" *ngFor="let l of FormData;let RowIndex = index">

              <div [id]="'accordion'+RowIndex">
                <div class="card-header wh-header font-size-16px  padding-top-6px padding-bottom-6px card-header-bg border-left-clinical padding-l-8px padding-right-8px font-weight-normal2 font-size-16px" [id]="'heading'+RowIndex">
                  <div class="row">
                    <div class="col-md-3">
                      <h5 class="mb-0">
                        <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" [attr.data-target]="'#collapse_cre'+RowIndex"
                                aria-expanded="true" [attr.aria-controls]="'collapse_cre'+RowIndex">
                          {{l.Title}}

                        </button>

                      </h5>
                    </div>
                    <div class="col-md-9">
                      <button type="submit" class="btn actions-btn-prime float-right">Save</button>
                      <button type="button"
                              (click)="Backtolist()" class="btn actions-btn-prime nav-link-hand button-Schedule actions-btn-prime3 float-right margin-right-10px">
                        Cancel
                      </button>
                    </div>
                  </div>


                </div>
                <div [id]="'collapse_cre'+RowIndex" class="collapse show collapse-show3" [attr.aria-labelledby]="'heading'+RowIndex"
                     [attr.data-parent]="'#accordion'+RowIndex">
                  <div class="card-body padding-bottom-19px padding-right-0px padding-top-0px">

                    <div class="row col-md-12 card" *ngFor="let f of l.Fields">


                      <div class="card-header wh-header font-size-14 padding-l-8px padding-t-6px padding-bottom-0px padding-right-0px" *ngIf="f.isHeader">
                        {{f.Title}}
                      </div>
                      <div class="card-body padding-bottom-0px padding-top-0px margin-left-zero">
                        <div *ngIf="f.isSubHeader">
                          <label class="font-size-14 margin-bottom-0px">{{f.Title}}</label>
                        </div>


                        <div *ngIf="f.isTextField">
                          <div class="row form-group">
                            <div class="col-md-3 padding-right-0px text-align-right">
                              <label class="font-size-12px margin-bottom-0px margin-top-10">{{f.Title}}</label>
                            </div>
                            <div class="col-md-3">
                              <input type="text" class="form-control" placeholder="Value" required maxlength="100" minlength="1">
                            </div>
                          </div>


                        </div>
                        <div *ngIf="f.isSubChild">
                          <div class="row form-group">
                            <div class="col-md-3 text-align-right">
                              <label class="font-size-12px margin-bottom-0px margin-top-10">{{f.Title}}</label>
                            </div>:
                            <div class="col-md-3">
                              <input type="text" class="form-control" placeholder="Value" required maxlength="100" minlength="1">
                            </div>
                          </div>
                        </div>


                        <div *ngIf="f.Remarks">
                          <label class="margin-left-10px margin-bottom-0px">{{f.Remarks}}</label>
                        </div>
                        <div *ngIf="f.HasSeparator">
                          <div class="border-bottom-light"></div>
                        </div>
                      </div>
                    </div>



                  </div>
                </div>
              </div>

            </div>

          </div>
        </div>
      </div>
    </div>
    <div class="col-md-4">

    </div>
  </div>-->
  <!--<div class="row">
    <div class="col-md-12">
      <medicalrecordview [FormattedCode]="FormattedCode" *ngIf="viewhealthrecord"></medicalrecordview>
    </div>

  </div>-->
